import Image, { StaticImageData } from 'next/image';
import Jonathan from './images/jonathan-photo.png';
import Nadim from './images/nadim-photo.png';
import Tommi from './images/tommi-photo.png';
import RainBow from './images/rainbow-illustration.png';
import { Description } from '@snapi/luxury';

interface AdvisorCardProps {
  img: StaticImageData;
  name: string;
  children?: React.ReactNode;
}

function AdvisorCard({ img, name, children }: AdvisorCardProps) {
  return (
    <div className="xs:flex xs:flex-row lg:flex-col lg:w-[420px] gap-5">
      <div className="w-[160px] xl:w-[200px] mb-5 sm:mb-0">
        <Image src={img} alt="" />
      </div>
      <div>
        <h4 className="mb-2">{name}</h4>
        <div className="w-[200px] mt-2 flex flex-col gap-2 text-body">
          <Description>{children}</Description>
        </div>
      </div>
    </div>
  );
}

export function AdvisorsSectionScience() {
  return (
    <section id="advisors-section-science">
      <div className="container relative">
        <div className="absolute top-[-100px] right-0 w-[140px] sm:right-0 sm:top-[30px] lg:w-[210px] lg:top-[-70px]">
          <Image src={RainBow} alt="" />
        </div>

        <h2 className="mb-10 max-w-[420px] md:max-w-[556px] lg:max-w-full">
          Let’s meet Snapi’s scientific advisory board
        </h2>
        <div className="flex flex-col gap-10 xl:gap-28 lg:flex-row lg:w-[420px] xl:w-[522px]">
          <AdvisorCard img={Tommi} name="Tommi Vatanen">
            <div className="opacity-70 flex flex-col gap-2">
              <div>University of Helsinki (primary)</div>
              <div>The Broad Institute of MIT and Harvard</div>
              <div>The Liggins Institute, University of Auckland</div>
            </div>
          </AdvisorCard>
          <AdvisorCard img={Nadim} name="Nadim Ajami">
            <div className="opacity-70 flex flex-col gap-2">
              <div>
                Ph.D. Executive Director for Scientific Research in MD Anderson
              </div>
              <div>Author of Teddy Study</div>
            </div>
          </AdvisorCard>
          <AdvisorCard img={Jonathan} name="Jonathan Eisen">
            <div className="opacity-70 flex">
              Professor, University of California, Davis (UC Davis), Department
              of Evolution and Ecology
            </div>
          </AdvisorCard>
        </div>
      </div>
    </section>
  );
}
